import { keyframes } from "src/lib/styles/css";

export default keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;